import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CsAgentAuthService } from '@spartacus/asm/root';
import {
  AuthRedirectService,
  BaseSiteService,
  CurrencyService,
  GlobalMessageService,
  GlobalMessageType,
  OCC_USER_ID_CURRENT,
  RoutingService,
  UserIdService,
} from '@spartacus/core';
import { EMPTY, catchError, take, tap } from 'rxjs';
import { DealerService } from 'src/app/service/asm/dealer.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { LogoutService } from 'src/app/service/user/logout.service';
import { ShimanoUtilMethod as ShimanoUtil } from 'src/app/utility/methods.util';

@Component({
  selector: 'app-dealer-list',
  templateUrl: './dealer-list.component.html',
  styleUrls: ['./dealer-list.component.scss'],
  standalone: false,
})
export class DealerListComponent implements OnInit {
  selected: any;
  prevSelected: any;
  dropdownIsOpened = false;
  disableDropdown: boolean = false;
  @Input() list: any;
  @Output() impersonationChange = new EventEmitter();
  @Input() isShipTo = false;
  impersonateURL: string;
  constructor(
    private logoutService: LogoutService,
    private authRedirectService: AuthRedirectService,
    private currencyService: CurrencyService,
    private routingService: RoutingService,
    private userIdService: UserIdService,
    private router: Router,
    private componentService: ComponentService,
    private location: Location,
    private shimanoLanguageService: ShimanoLanguageService,
    private csAgentAuthService: CsAgentAuthService,
    private storageService: StorageService,
    protected baseService: BaseSiteService,
    private dealerService: DealerService,
    private messageService: GlobalMessageService
  ) {}

  ngOnInit() {
    this.selected = this.list.administrators
      ? this.list.administrators[0]
      : this.list.managers
      ? this.list.managers[0]
      : this.list.customers
      ? this.list.customers[0]
      : '';
  }

  onCustomerSelection(customerId: any) {
    this.selected = customerId;
  }

  onOpenDropdown(event: any, uidClassName: string) {
    this.dropdownIsOpened = event;
    if (event && uidClassName === this.list.uid) this.scrollIntoViewSelectedDealer(uidClassName);
  }

  startImpersonate(list: any, onInit = false) {
    this.userIdService.getUserId().pipe(
      take(1),
      tap((userId) => {
        this.prevSelected = userId;
        let isPageLoadedFromLogin = this.storageService.getSessionStorageItem('pageLoadedFromLogin');
        if (
          isPageLoadedFromLogin !== 'true' &&
          this.prevSelected !== OCC_USER_ID_CURRENT &&
          this.prevSelected !== this.selected.uid
        ) {
          this.logoutService.logout();
        }
      })
    );

    if (this.isShipTo && !this.selected) {
      this.dealerService
        .getOrCreateShipToDummyAccount(list.orgUnit.uid, list.id)
        .pipe(
          take(1),
          tap((data) => {
            this.selected = data;
            if (this.selected) {
              this.disableDropdown = true;
              this.completeImpersonation(list, onInit);
            }
          }),
          catchError((err) => {
            this.messageService.add({ key: 'cart.genericError' }, GlobalMessageType.MSG_TYPE_ERROR);
            return EMPTY;
          })
        )
        .subscribe();
    } else {
      this.completeImpersonation(list, onInit);
    }
  }

  completeImpersonation(list: any, onInit = false) {
    this.setActiveSiteContexts(this.selected);

    if (this.isShipTo) {
      localStorage.setItem('shimanoSessionB2BUnitname', this.list.orgUnit.uid);
      localStorage.setItem('shimanoSessionB2BUnit', this.list.orgUnit.uid);
    } else {
      localStorage.setItem(
        'shimanoSessionB2BUnitname',
        this.selected.orgUnit.name ? this.selected.orgUnit.name : this.selected.company
      );
      localStorage.setItem('shimanoSessionB2BUnit', this.selected.orgUnit.uid);
    }
    setTimeout(() => {
      this.csAgentAuthService.startCustomerEmulationSession(this.selected.uid);
      this.storageService.removeLocalStorageItem('asmReload');
      this.storageService.removeSessionStorageItem('pageLoadedFromLogin');
      if (this.impersonateURL) {
        window.location.href = this.impersonateURL;
      } else {
        this.router.navigate(['/']);
      }
    }, 0);
  }

  setActiveSiteContexts(selectedPerson: any) {
    const siteContextsFromUid = selectedPerson.uid.split(':', 2);
    const country = siteContextsFromUid[1];
    const language = selectedPerson.language.isocode;
    const currency = selectedPerson.currency.isocode;

    const siteContextsFromPathname = this.location.path().split('/', 4);
    const countryFromPathname = siteContextsFromPathname[2];
    const languageFromPathname = siteContextsFromPathname[3];

    // no page reload if same siteContext
    if (
      country === countryFromPathname &&
      language === languageFromPathname &&
      siteContextsFromUid[0] === siteContextsFromPathname[1]
    ) {
      return;
    } else {
      this.storageService.setSessionStorageItem('countrySelected', country.toUpperCase());
      this.storageService.setSessionStorageItem('language', language.toLowerCase());
      this.impersonateURL = siteContextsFromUid[0] + '/' + country + '/' + language + '/';

      const businessType =
        'shimano' +
        siteContextsFromUid[0].charAt(0).toUpperCase() +
        siteContextsFromUid[0].slice(1) +
        '-' +
        siteContextsFromUid[1];

      if (siteContextsFromUid[0] !== siteContextsFromPathname[1]) {
        this.baseService.setActive(businessType);
      }

      if (currency !== 'undefined') {
        this.currencyService.setActive(currency);
        this.storageService.setLocalStorageitem('userCurrency', currency);
        this.storageService.setSessionStorageItem('userCurrencySym', currency);
      } else {
        this.storageService.removeLocalStorageItem('userCurrency');
        this.storageService.removeLocalStorageItem('userCurrencySym');
      }
      if (typeof language !== 'undefined' && language !== languageFromPathname) {
        this.shimanoLanguageService.setActive(language);
        this.storageService.setLocalStorageitem('language', language);
        this.storageService.setSessionStorageItem('language', language);
      } else {
        this.storageService.removeLocalStorageItem('language');
        this.storageService.removeSessionStorageItem('language');
      }
    }
  }

  getAllDealers(administrators: any[], managers: any[], customers: any[]): any[] {
    return []
      .concat(administrators, managers, customers)
      .filter((dealer, i, allDealers) => dealer && allDealers.indexOf(dealer) === i)
      .sort((a, b) =>
        this.getSelectedName(a.firstName, a.lastName, a.name, a.email).localeCompare(
          this.getSelectedName(b.firstName, b.lastName, b.name, b.email)
        )
      );
  }

  getSelectedName(firstName: any, lastName: any, fullName: any, email: any): string {
    let fname = '',
      lname = '',
      name = '';

    if (!ShimanoUtil.isPropertyUndefined(firstName) && ShimanoUtil.isPropertyHasValue(firstName)) {
      fname = firstName;
    }
    if (!ShimanoUtil.isPropertyUndefined(lastName) && ShimanoUtil.isPropertyHasValue(lastName)) {
      lname = lastName;
    }
    if (!ShimanoUtil.isPropertyUndefined(fullName) && ShimanoUtil.isPropertyHasValue(fullName)) {
      name = fullName;
    }

    if (ShimanoUtil.isPropertyHasValue(fname) || ShimanoUtil.isPropertyHasValue(lname)) {
      return [fname, lname].join(' ');
    } else if (ShimanoUtil.isPropertyHasValue(name)) {
      return name;
    } else {
      return email;
    }
  }

  isDisabled(firstName: any, lastName: any, fullName: any, email: any): boolean {
    return !this.getSelectedName(firstName, lastName, fullName, email);
  }

  setOneWord(className: string): string {
    return className.split(' ').join('-').toLowerCase();
  }

  scrollIntoViewSelectedDealer(uidClassName: string) {
    setTimeout(() => {
      const activeDealerSelectionEl = document.getElementsByClassName(this.setOneWord(uidClassName))[0] as HTMLElement;
      const selectedDealer = activeDealerSelectionEl.getElementsByClassName('selected')[0] as HTMLElement;
      selectedDealer.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  isStartBtnDisabled(): boolean {
    if (this.isShipTo) {
      return !this.list?.orgUnit?.active;
    }
    if (!this.selected) {
      return true;
    } else {
      return false;
    }
  }
}
